import React from 'react';
import Table from '../Table';

const title = "Other Details";
const columns = [
	{
		name: 'Retrieval Interval Months',
		selector: 'retrievalIntervalMonths',
		sortable: false,
	},
	{
		name: 'Recurring Income Calculation',
		selector: 'recurringIncomeCalculation',
		sortable: false
	},
	{
		name: 'Top Line Calculation Interval Months',
		selector: 'topLineIncomeCalculationIntervalMonths',
		sortable: false
	}
];

function ThresholdTableOther(props) {
	return (
		<Table className="thresholdTable" title={title} columns={columns} data={props.data} pagination={false} />
	);
}

export default ThresholdTableOther;